module.exports = __webpack_public_path__ + "img/messenger-instruction-2.8fc5459c.png";